<div class="wrap-intro" *ngIf="env.SHOW_SELL_AN_ITEM">
  <div class="intro-section desktop">
    <div class="col-lg-6 col-md-6 col-sm-6 imgbox">
      <a href="{{ section_1.link }}">
        <img
          [defaultImage]="'assets/images/placeholder.png'"
          [errorImage]="'assets/images/placeholder.png'"
          lazyLoad="{{ env.UPLOADS_IMGIX_URL }}dynamic/homepage/{{ section_1.image_url }}.{{ section_1.extension }}"
          class="img-responsive w-100 forOther"
          alt="{{ section_1.image_url }}.{{ section_1.extension }}"
          *appShellNoRender
        />
      </a>
    </div>
    <div class="col-lg-5 col-md-5 col-sm-5 product-title" *ngIf="section_2 != null">
      <div class="text-section">
        <div class="wrap">
          <div class="join-us">Join 200.000+ cool girls</div>
          <h3 [innerHTML]="section_2.title"></h3>
          <h4 [innerHTML]="section_2.description"></h4>
          <div class="cta-btn">
            <a href="{{ section_2.link }}">{{ section_2.button }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="intro-section mobile">
    <div class="col-lg-5 col-md-5 col-sm-5 product-title" *ngIf="section_2 != null">
      <div class="text-section">
        <div class="join-us">Join 200.000+ cool girls</div>
        <h3 [innerHTML]="section_2.title"></h3>
        <h4 [innerHTML]="section_2.description"></h4>
        <div class="cta-btn">
          <a href="{{ section_2.link }}">{{ section_2.button }}</a>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 imgbox">
      <a href="{{ section_1.link }}">
        <img
          [defaultImage]="'assets/images/placeholder.png'"
          [errorImage]="'assets/images/placeholder.png'"
          lazyLoad="{{ env.UPLOADS_IMGIX_URL }}dynamic/homepage/{{ section_1.image_url }}.{{ section_1.extension }}"
          class="img-responsive w-100 forOther"
          alt="{{ section_1.image_url }}.{{ section_1.extension }}"
          *appShellNoRender
        />
      </a>
    </div>
  </div>
</div>
